import { termsOfServiceContent } from '@/config/marketing-content/legal-pages'
import { LegalDocumentLayout } from '@/components/marketing/legal-document-layout'

export function TermsOfServicePage() {
  return <LegalDocumentLayout document={termsOfServiceContent} />
}
